import { EMPTY_OBJECT } from '../../../constants/common'
import TextComponent from '../../Text'

import * as styles from './FloatingTooltipContentText.module.css'

function FloatingTooltipContentText({
  AdditionalText = TextComponent,
  Text = TextComponent,
  additionalText,
  additionalTextProps: {
    className: additionalTextClassName = styles.additionalText,
    ...additionalTextProps
  } = EMPTY_OBJECT,
  className = styles.FloatingTooltipContentText,
  text,
  textProps: {
    className: textClassName = styles.text,
    ...textProps
  } = EMPTY_OBJECT,
}) {
  return (
    <div className={className}>
      {Text && text ? (
        <Text {...textProps} className={textClassName}>
          {text}
        </Text>
      ) : null}
      {AdditionalText && additionalText ? (
        <Text {...additionalTextProps} className={additionalTextClassName}>
          {additionalText}
        </Text>
      ) : null}
    </div>
  )
}

export default FloatingTooltipContentText
